import React, { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { useDispatch, useSelector } from "react-redux";
import { buyModalShow, updateListingItems } from "../../redux/marketplaceSlice";
import { useRouter } from "next/router";
import {
  listHandle,
  unlistHandle,
  updatePriceHandle,
  buyHandle,
  buyPalletHandle,
  approveHandle,
} from "../../api/index";
import { useSigningCosmWasmClient, useWallet } from "@sei-js/react";
import { toast } from "react-toastify";
import { COLLECTIONS, DECIMAL } from "../../config";
import {
  createListing,
  updateListing,
  deleteListing,
  buy,
  getUserListings
} from "../../utils/api";
import { updateCart } from "../../redux/marketplaceSlice";

const categoryItemDetail = ({ item, signingClient, collections }) => {
  /* eslint-disable */
  // const { signingCosmWasmClient: signingClient } = useSigningCosmWasmClient();
  const dispatch = useDispatch();
  const router = useRouter();

  const [loading, setLoading] = useState(false);
  const [price, setPrice] = useState("");
  const [mode, setMode] = useState("Listing"); // Listing, UnListing, Buy
  const [listingId, setListingId] = useState();
  const [detailUrl, setDetailUrl] = useState("");

  const { cart, seiWallet, listingItems } = useSelector((state) => state.marketplace);

  const listAction = async (data) => {
    if (loading) {
      return toast.warning("Can't click twice", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    if (!seiWallet) {
      return toast.warning("Please connect the wallet", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    if (!price || Number(price) <= 0) {
      return toast.warning("Please input the price", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    if (!collections.includes(data.contract)) {
      return toast.warning("No registered collection!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }

    setLoading(true);

    let id = toast.loading("Listing...", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });

    const res = await listHandle(signingClient, seiWallet, {
      ...data,
      price: price * DECIMAL,
    });

    console.log("res: ", res);
    if (res.success) {
      await createListing({ ...data, price, address: seiWallet });
      getUserListings({user: seiWallet, subquery: 0}).then(async data => {
        await dispatch(updateListingItems(data))
        toast.update(id, {
          render: "Listed successfully",
          type: "success",
          autoClose: 2000,
          isLoading: false,
        });
        setMode("UnListing");
      });
    } else {
      toast.update(id, {
        render: "Listing Failed",
        type: "error",
        autoClose: 2000,
        isLoading: false,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    // console.log("listingItems: ", listingItems);
    // console.log("item: ", item);
    if (item?.filter == true) setMode("Buy");
    for (let i = 0; i < listingItems.length; i++) {
      if (
        item?.token_id == listingItems[i].token_id &&
        listingItems[i].seller == seiWallet
      ) {
        setPrice((listingItems[i].price / DECIMAL).toFixed(3));
        setListingId(listingItems[i].id);
        setMode("UnListing");
      } else if (
        item?.token_id == listingItems[i].token_id &&
        listingItems[i].seller != seiWallet
      ) {
        setListingId(listingItems[i].id);
        setMode("Buy");
      } else {
        // setMode("Buy");
        // setListingId(listingItems[i].id);
      }
    }
  }, [item, listingItems]);

  useEffect(() => {
    if (router) {
      if (router.pathname.includes("collection")) {
        if (item.marketplace == "pallet") {
          setDetailUrl(`/item/${item.collection_key}/${token_id}?external=true`)
        }
        else {
          setDetailUrl(`/item/${collection ? collection : contract}/${token_id}?external=false`)
        }
      }
      else if (router.pathname.includes("user")) {
        if (item.marketplace == "pallet") {
          setDetailUrl(`/ownitem/${item.collection_key}/${token_id}`)
        }
        else {
          setDetailUrl(`/ownitem/${collection ? collection : contract}/${token_id}`)
        }
      }
    }
  }, [router])

  const unListAction = async (data) => {
    if (loading) {
      return toast.warning("Can't click twice", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    if (!seiWallet) {
      return toast.warning("Please connect the wallet", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    setLoading(true);

    let id = toast.loading("Unlisting...", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });

    const res = await unlistHandle(signingClient, seiWallet, data);
    if (res.success) {
      await deleteListing({
        ...data,
        price,
        address: seiWallet,
        price: price * DECIMAL,
        listing_id: listingId,
      });
      setMode("Listing");
      setPrice("");
      toast.update(id, {
        render: "Unlisted successfully",
        type: "success",
        autoClose: 2000,
        isLoading: false,
      });
    } else {
      toast.update(id, {
        render: "Unlisting Failed",
        type: "error",
        autoClose: 2000,
        isLoading: false,
      });
    }
    setLoading(false);
  };

  const updatePriceAction = async (data) => {
    if (loading) {
      return toast.warning("Can't click twice", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    if (!seiWallet) {
      return toast.warning("Please connect the wallet", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    if (!price || Number(price) <= 0) {
      return toast.warning("Please input the price", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    setLoading(true);

    let id = toast.loading("updatePricing...", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });

    const res = await updatePriceHandle(signingClient, seiWallet, {
      ...data,
      price: price * DECIMAL,
    });
    if (res.success) {
      await updateListing({
        ...data,
        price,
        address: seiWallet,
        price: price * DECIMAL,
        listing_id: listingId,
      });
      toast.update(id, {
        render: "UpdatePrice successfully",
        type: "success",
        autoClose: 2000,
        isLoading: false,
      });
    } else {
      toast.update(id, {
        render: "UpdatePrice Failed",
        type: "error",
        autoClose: 2000,
        isLoading: false,
      });
    }
    setLoading(false);
  };

  const buyAction = async (data) => {
    if (loading) {
      return toast.warning("Can't click twice", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    if (!seiWallet) {
      return toast.warning("Please connect the wallet", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }

    setLoading(true);

    let id = toast.loading("Buying...", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });

    console.log("buy: ", data);

    if (data?.marketplace == "pallet") {
      const res = await buyPalletHandle(signingClient, seiWallet, data);
      if (res.success) {
        toast.update(id, {
          render: "Bought successfully",
          type: "success",
          autoClose: 2000,
          isLoading: false,
        });
        setMode("Listing");
      } else {
        toast.update(id, {
          render: "Buy Failed",
          type: "error",
          autoClose: 2000,
          isLoading: false,
        });
      }
    } else {
      const res = await buyHandle(signingClient, seiWallet, data);

      if (res.success) {
        await buy({ ...data, address: seiWallet });
        setMode("Listing");
        toast.update(id, {
          render: "Bought successfully",
          type: "success",
          autoClose: 2000,
          isLoading: false,
        });
      } else {
        toast.update(id, {
          render: "Buy Failed",
          type: "error",
          autoClose: 2000,
          isLoading: false,
        });
      }
    }

    setLoading(false);
  };

  const addToCartAction = () => {
    if (!seiWallet) {
      return toast.warning("Please connect the wallet", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    let flag = 1;
    for (let i = 0; i < cart.length; i++) {
      if (cart[i].id == item.id) flag = 0;
    }
    if (flag == 0) {
      return toast.warning("Already added", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    } else {
      toast.success("Successfully added", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    const temp = [...cart];
    temp.push({ ...item, address: seiWallet });
    dispatch(updateCart({ cart: temp }));
  };

  const {
    id,
    token_id,
    image,
    title,
    bidLimit,
    bidCount,
    contract,
    likes,
    creator,
    owner,
    collection,
  } = item;

  const showBuyField = () => {
    let field = null;
    if (mode == "Buy") {
      if (item?.price) {
        field = (
          <div className="mt-8 flex items-center justify-between">
            <button
              className="text-accent font-display text-sm font-semibold"
              onClick={
                () => buyAction(item)
                // dispatch(buyModalShow())
              }
            >
              Buy now
            </button>
            <Link
              href={detailUrl}
            >
              <a className="group flex items-center">
                <svg className="icon icon-history group-hover:fill-accent dark:fill-jacarta-200 fill-jacarta-500 mr-1 mb-[3px] h-4 w-4">
                  <use xlinkHref="/icons.svg#icon-history"></use>
                </svg>
                <span className="group-hover:text-accent font-display dark:text-jacarta-200 text-sm font-semibold">
                  View History
                </span>
              </a>
            </Link>
          </div>
        );
      } else {
        field = (
          <div>
            <Link
              href={detailUrl}
            >
              <a className="group flex items-center justify-center">
                <svg className="icon icon-history group-hover:fill-accent dark:fill-jacarta-200 fill-jacarta-500 mr-1 mb-[3px] h-4 w-4">
                  <use xlinkHref="/icons.svg#icon-history"></use>
                </svg>
                <span className="group-hover:text-accent font-display dark:text-jacarta-200 text-sm font-semibold">
                  View History
                </span>
              </a>
            </Link>
          </div>
        );
      }
    }

    return field;
  };

  return (
    <article className="mr-6 mb-5">
      <div className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2.5xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg h-full flex flex-col justify-between ">
        <figure className="relative">
          <Link
            href={detailUrl}
          >
            <a>
              <img
                src={image ? image : "/images/products/item_5.jpg"}
                alt="SEI"
                className="w-full h-[230px] rounded-[0.625rem] object-cover"
              />
            </a>
          </Link>
          {/* <Likes like={likes ? likes : 1} /> */}

          <div className="absolute left-3 -bottom-3">
            <div className="flex -space-x-2">
              {/* <Link href={`/item/${itemLink}`}>
                      <a>
                        <Tippy content={<span>creator: {creator.name}</span>}>
                          <img
                            src={creator.image}
                            alt="creator"
                            className="dark:border-jacarta-600 hover:border-accent dark:hover:border-accent h-6 w-6 rounded-full border-2 border-white"
                          />
                        </Tippy>
                      </a>
                    </Link>
                    <Link href={`/item/${itemLink}`}>
                      <a>
                        <Tippy content={<span>creator: {owner.name}</span>}>
                          <img
                            src={owner.image}
                            alt="owner"
                            layout="fill"
                            className="dark:border-jacarta-600 hover:border-accent dark:hover:border-accent h-6 w-6 rounded-full border-2 border-white"
                          />
                        </Tippy>
                      </a>
                    </Link> */}
            </div>
          </div>
        </figure>
        <div className="mt-7 flex items-center justify-between">
          <Link
            href={detailUrl}
          >
            <a>
              <span className="font-display text-jacarta-700 hover:text-accent text-base dark:text-white">
                {title}
              </span>
            </a>
          </Link>

          {/* auction dropdown  */}
          {/* <Auctions_dropdown classes="dark:hover:bg-jacarta-600 dropup hover:bg-jacarta-100 rounded-full " /> */}
        </div>
        
        <div className="mt-2 text-sm">
          <span className="dark:text-jacarta-200 text-jacarta-700 mr-1">
            {mode == "Buy"
              ? item?.price
                ? (item?.price / DECIMAL).toFixed(3)
                : null
              : null}
          </span>
          <span className="dark:text-jacarta-300 text-jacarta-500">
            {false ? bidCount / bidLimit : null}
          </span>
        </div>

        {item?.price && (
          <div className="mt-2 text-sm">
            <button
              className="text-accent font-display text-sm font-semibold"
              onClick={
                () => addToCartAction(item)
                // dispatch(buyModalShow())
              }
            >
              <Image src="/cart_icon.png" alt="cart" width={26} height={26} />
            </button>
          </div>
        )}

        {showBuyField()}

        {mode == "UnListing" ? (
          <div className="mt-8 flex items-center  flex-col">
            <div className="mt-5 w-full flex items-center justify-around ">
              <input
                type="text"
                value={price}
                placeholder="Price"
                className="dark:bg-jacarta-700 dark:border-jacarta-600 focus:ring-accent border-jacarta-100 w-28 rounded-full border py-3 px-4 dark:text-white dark:placeholder-white"
                onChange={(e) => {
                  setPrice(e.target.value);
                }}
              />
              <button
                className="text-accent font-display text-sm font-semibold w-1/2  bg-red-700"
                onClick={() => {
                  updatePriceAction(item);
                }}
              >
                Update
              </button>

              <button
                className="text-accent font-display text-sm font-semibold w-1/2  bg-green-600"
                onClick={() => {
                  unListAction(item);
                }}
              >
                UnList
              </button>
            </div>
          </div>
        ) : null}

        {mode == "Listing" ? (
          <div className="mt-8 flex items-center justify-between">
            <input
              type="text"
              value={price}
              placeholder="Price"
              className="dark:bg-jacarta-700 dark:border-jacarta-600 focus:ring-accent border-jacarta-100 w-28 rounded-full border py-3 px-4 dark:text-white dark:placeholder-white"
              onChange={(e) => {
                setPrice(e.target.value);
              }}
            />

            <button
              className="text-accent font-display text-sm font-semibold"
              onClick={() => {
                listAction(item);
              }}
            >
              List now
            </button>
          </div>
        ) : null}
      </div>
    </article>
  );
};

export default categoryItemDetail;
